export default __webpack_public_path__ + "static/media/blog_inner_11.0dadb27c.png";